<template>
  <v-list-item dense @click="$emit('click')">
    <v-list-item-content class="py-auto">
      <v-list-item-title>
        <span class="primary--text mr-3">{{ item.Id }}</span>
        {{ item.Name }}
      </v-list-item-title>
    </v-list-item-content>
  </v-list-item>
</template>


<script>
import CheckListConstants from "@/helpers/Constants/CheckListConstants";

export default {
  name: "CheckListTemplateListItem",
  props: {
    item: Object,
  },
  components: {
  },
  mixins: [],

  data() {
    return {
    };
  },

  mounted() { },

  methods: {},

  computed: {
    typeText() {
      return CheckListConstants.templateTypes[this.item.TemplateType].text;
    }
  },

  watch: {},
};
</script>


<style lang='scss' scoped></style>